export const getters = {
  getSelectedShippingItems (state) {
    return state.shipping || []
  },
  getFinalShippingPrice (state) {
    return state.finalShippingPrice
  },
  isSameAsShippingSent (state) {
    return state.isSameAsShippingSent
  },
}
